import IconBase from "./IconBase";

const CopyIcon = (props) => (
    <IconBase {...props}>
        <rect x="9" y="9" width="12" height="12" rx="2.5" />
        <path d="M15 5.5v-1a2 2 0 0 0-2-2H4.5a2 2 0 0 0-2 2V13a2 2 0 0 0 2 2h1" />
    </IconBase>
);

export default CopyIcon;
